import { useCallback, useEffect, useMemo, useState } from "react";

import { Eye, X } from "lucide-react";
import { Badge, Button, ListItem } from "twyne-new.ui";

import { formatDate } from "utils";

export default function Item({ version, isPreview, onView, onReset, onSave }) {
  const [hover, setHover] = useState(false)
  const [name, setName] = useState(null)

  const saveMode = useMemo(() => version.meta?.saveMode || "manual", [version])
  const createdAt = useMemo(() => formatDate(version.createdAt, "MMM DD, YYYY - hh:mm A"), [version])
  const user = useMemo(() => {
    const { first_name, last_name } = version.user || {}
    return first_name || last_name ? `${first_name} ${last_name}` : "--"
  }, [version])

  const handleChange = useCallback(event => {
    const { value } = event.target
    setName(value)
  }, [])

  const handleSave = useCallback(async () => {
    if (!name) return;

    await onSave({
      id: version.id,
      meta: {
        ...version.meta || {},
        versionName: name,
      },
    })
  }, [version, onSave, name])

  useEffect(() => {
    const { versionName } = version.meta || {}
    if (versionName) {
      setName(name => name || versionName)
    }
  }, [version])

  return <ListItem
    className="p-3 justify-between items-center"
    selected={isPreview}
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}
  >
    <div className="flex flex-col gap-1">
      <input
        className="p-0 m-0 bg-transparent border-0 outline-0 text-base font-normal"
        value={name === null ? createdAt : name}
        onChange={handleChange}
        onBlur={handleSave}
      />
      <div className="flex items-center gap-2">
        <Badge size="sm" color="accent" variant={saveMode === "manual" ? "default" : "outline"} className="text-sm font-normal">
          {saveMode}
        </Badge>
        <div className="text-sm font-normal">
          {user}
        </div>
      </div>
    </div>
    { hover || isPreview ? <Button className="p-0" variant="ghost" size="sm" onClick={isPreview ? onReset : () => onView(version)}>
      { isPreview ? <X size={14} /> : <Eye size={14} /> }
    </Button> : null }
  </ListItem>
}
